import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "nav"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.show_nav)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_NavHeader)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { style: {"min-width":"768px","min-height":"calc(100% - 62px)"} })
  ], 64))
}